/*klaviyo*/
var klavscript = document.createElement('script');
klavscript.type = 'text/javascript';
klavscript.id = 'klav-snippet';
klavscript.src = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
document.getElementsByTagName('head')[0].appendChild(klavscript);

var currentDate = new Date().toISOString();

function getFormattedDate() {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date();

    const day = String(date.getDate()).padStart(2, '0');
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(3, '0');
  
    return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}.${milliseconds}`;
}

var dm = window.location.hostname;
var kstore = "HYypch";
var klist  = "NnwXsU";
var kreglist = "HaaEup";
var kquizlist  = "RNMsEc";
if ((dm == "world.mysteryvibe.com") || (dm == "worldblog.mysteryvibe.com") || (dm == "mysteryvibe.myshopify.com")) {
  kstore = "Kf8zGu";
  klist  = "L9eTfV";
  kreglist = "JA6m9E";
  kquizlist  = "VMHqWZ";
}
else if ((dm == "mysexmd.com") || (dm == "mysexmd.myshopify.com") || (dm == "mv.health")) {
  kstore = "Kv6pwU";
  klist  = "Jr2P2g";
  kreglist = "YkwqqA";
  kquizlist  = "";
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
$(document).ready(function () {    
  $('.phone-field').keypress(function (e) {    
    var charCode = (e.which) ? e.which : event.keyCode    
    if (String.fromCharCode(charCode).match(/[^0-9+]/g)) { 
      return false;                        
    }    
  });  
});

function openSideCart() {
  try {
    $.get('/cart?view=m', function(data, status){
      if (data.length > 0) {
        var newdata = ("<doc>"+data+"</doc>")
        var theResponse = $(newdata).find('.mobile-cart-parent').html(); 
        /*console.log(theResponse);*/
        if (theResponse.length) {
          $("#cart-popup .popup-image-container").html(theResponse);
        }
      }   
    });
		$.fancybox.open([
      {
        src: '#cart-popup',
      },
    ]);
  }
  catch (err) {
    console.log("ERROR: "+err.message);
  } 
}
function updateSideCart() {
  try {
    $.get('/cart?view=m', function(data, status){
      if (data.length > 0) {
        var newdata = ("<doc>"+data+"</doc>")
        var theResponse = $(newdata).find('.mobile-cart-parent').html(); 
        /*console.log(theResponse);*/
        if (theResponse.length) {
          $("#cart-popup .popup-image-container").html(theResponse);
          updateSideCartCount();
        }
      }   
    });
  }
  catch (err) {
    console.log("ERROR: "+err.message);
  } 
}
function updateSideCartCount() {
  try {
    var countAttr = $('.side-cart').attr('count');
    var count = parseInt(countAttr, 10);
    if (!isNaN(count)) {
      $('.header-cart-quantity').text(count);
    } else {
      console.warn("Invalid cart count attribute:", countAttr);
    }
  }
  catch (err) {
    console.log("ERROR: "+err.message);
  } 
}

$(document).ready(function () {

  $(document).on('click', '.cart-icon', function() {
    try { 
      openSideCart();
  	} catch (err_cart_btn) {
      console.log("ERROR: "+err_cart_btn.message);
    }
  });  

  $(document).on('click', '.cart-radio-switch.active-switch', function() {
  	try { 
      var vari = $(this).attr("value");
      var vkey = $(this).attr("vkey");
      var quan = $(this).attr("quan");      
      var nulldata = {
        "quantity": 0,
        "id": vkey
      }
      var nullparams = {
        type: 'POST',
        url: '/cart/change.js',
        data: nulldata,
        dataType: 'json',
        success: function(line_item) {
          console.log("Removing Variant '"+vkey+"' complete");
          
          if ($('.cart__quantity-selector[variant="'+vari+'"]').length > 0) {
            var wasquantity = parseInt($('.cart__quantity-selector[variant="'+vari+'"]').first().val(),10);
            var newquantity = wasquantity + parseInt(quan,10);
            console.log(wasquantity+" to "+newquantity);
            $('.cart__quantity-selector[variant="'+vari+'"]').first().val(newquantity);
            $('.cart__quantity-selector[variant="'+vari+'"]').first().trigger('change');
            console.log("Adding Variant Quantity '"+vari+"' complete");
          }
          else {          
            var data = {
              "quantity": 1,
              "id": vari
            }
            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function(line_item) {
                console.log("Adding Variant '"+vari+"' complete");
                //REBUILD CART
                updateSideCart();
                $('.update-cart.btn').trigger('click');
              },
              error: function(XMLHttpRequest, textStatus) {
              }
            };
            jQuery.ajax(params);
          }
          
        },
        error: function(XMLHttpRequest, textStatus) {
        }
      };
      jQuery.ajax(nullparams);  
  	} catch (err_cart_add) {}
  }); 

  $(document).on('change', '.cart__quantity-selector', function() {
  	try { 
      var obj = $(this);
      setTimeout(function(){
        var quantity = obj.val();
        var key = obj.closest('.cart-quantity').attr('key');
        console.log("Key: "+key+", Quantity: "+quantity)
        var data = {
          "quantity": quantity,
          "id": key
        }
        var params = {
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function(line_item) {
            console.log("Changing Variant Quantity '"+key+"' complete");
            //REBUILD CART
            updateSideCart();
			      $('.update-cart.btn').trigger('click');
          },
          error: function(XMLHttpRequest, textStatus) {
          }
        };
        jQuery.ajax(params);
      }, 1000);
  	} catch (err_cart_quantity_change) {
      console.log("ERROR: "+err_cart_quantity_change.message);
    }
  });

  $(document).on('click', '.cart__quantity-delete', function() {
  	try { 
      var obj = $(this);
      setTimeout(function(){
        var quantity = 0;
        var key = obj.attr('key');
        console.log("Key: "+key+", Quantity: "+quantity)
        var data = {
          "quantity": quantity,
          "id": key
        }
        var params = {
          type: 'POST',
          url: '/cart/change.js',
          data: data,
          dataType: 'json',
          success: function(line_item) {
            console.log("Changing Variant Quantity '"+key+"' complete");
            //REBUILD CART
            updateSideCart();
			      $('.update-cart.btn').trigger('click');
          },
          error: function(XMLHttpRequest, textStatus) {
          }
        };
        jQuery.ajax(params);
      }, 1000);
  	} catch (err_cart_quantity_change) {
      console.log("ERROR: "+err_cart_quantity_change.message);
    }
  });

  $(document).on('click', '.cart-upsell-banner', function() {
  	try { 
      var vari = $(this).attr("upsell");
      var data = {
        "quantity": 1,
        "id": vari
      }
      /*
        "properties": {
          '_source': 'upsellcard'
        }      
      */
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(line_item) {
          console.log("Adding Upsell Variant '"+vari+"' complete");
          //REBUILD CART
          updateSideCart();
          $('.update-cart.btn').trigger('click');
        },
        error: function(XMLHttpRequest, textStatus) {
        }
      };
      jQuery.ajax(params);
  	} catch (err_cart_upsell_change) {}
  });

  $(document).on('click', '.cart_add_item', function() {
  	try { 
      var vari = $(this).attr("variant");
      var source = $(this).attr("sourcevalue");
      var data = {
        "quantity": 1,
        "id": vari,
        "properties": {
          '_source': source,
          '_simple': source
        }  
      }
      var offer = $(this).attr("offer");
      if (offer) {
        data.properties['_simple'] = offer;
      }
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(line_item) {
          console.log("Adding Upsell Variant '"+vari+"' complete");
          //REBUILD CART
          updateSideCart();
          $('.update-cart.btn').trigger('click');
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log("Error");
        }
      };
      jQuery.ajax(params);
  	} catch (err_cart_upsell_change) {
      console.log("Cart_add_item error: "+err_cart_upsell_change.message);
    }
  });
  
  function applyQty($input, n){
    /*console.log("New quanity "+n);*/
    const min = parseInt($input.attr('min')||'0',10);
    const max = parseInt($input.data('max')||'9999',10);
    /*console.log("Min "+min+", Max "+max);*/
    let v = parseInt(n,10); if(isNaN(v)) v=min;
    v = Math.max(min, Math.min(max, v));
    /*console.log("Value "+v);*/
    if(parseInt($input.val(),10)!==v){ $input.val(v).trigger('change'); }
  }
  $(document).on('click','.cart-popup .qty-up',function(){
    const $i = $(this).siblings('input.cart__quantity-selector').first();
    var val = (parseInt($i.val()||'0',10) + 1);
    console.log("Cart increase quantity to "+val);
    applyQty($i, val);
  });
  $(document).on('click','.cart-popup .qty-down',function(){
    const $i = $(this).siblings('input.cart__quantity-selector').first();
    var val = (parseInt($i.val()||'0',10) - 1);
    console.log("Cart decrease quantityy to "+val);
    applyQty($i, val);
  });

});

$(document).ready(function () {
  
  try {
  	$('.klaviyo_submit_button').on('click', function() {
      try {
        geq.suppress();
      } catch (err_geq) {console.log("GEQ Error: "+err_geq.message);}
      console.log("Klaviyo getemails supress");
    });
  } catch (err_klav_getemails) {
    console.log("GetEmails Klaviyo Error: "+err_klav_getemails.message);
  }
  
    function trackLead($source) {
      // Tag manager
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'form_submitted',
        lead_source: $source
      });
    try {
      geq.suppress();
    } catch (err_geq) {console.log("GEQ Error: "+err_geq.message);}
      Cookies.set('popup_seen', 'true');
    }

  var currentDate = new Date().toISOString();

    $(document).on('submit', '#footer_email_subscribe', function(){
          var kform = $('#footer_email_subscribe');
          var kmail = kform.find('[name="email"]').val();
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
        $source: 'Footer',
        $method_id: 'embed',
        'Accepts Marketing': true,
        'Subscribed to Footer': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
        trackLead('Footer');
            
                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);
            
              kform.find('[class^="input-group"]').hide();
              kform.find('.klaviyo_messages .success_message').show();

          })
          .catch((err) => {
            console.log("Error: " +err);
          });
    });

    $(document).on('submit', '#landing-email', function(){
          var kform = $('#landing-email');
          var kmail = kform.find('[name="email"]').val(); 
          var klist = kform.find('[name="g"]').val(); 
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
        $source: $('#campaignnm').val(),
        $method_id: 'embed',
        'Accepts Marketing': true,
              'Subscribed to an Email Landing': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
        trackLead($('#campaignel').val());
            
            var learnq = learnq || [];
            _learnq.push(['identify', {
                    '$email' : kmail
            }]);
            var data = {};
            var datt = $('#campaignst').attr("name");
            data[datt] = currentDate;
            _learnq.push(['identify', data]);
            
              console.log(datt);
        $('.landing-email-capture .email-pre').hide();
        $('.landing-email-capture .email-post').show();
        $('.email-capture-form').hide();

                })
          .catch((err) => {
            console.log("Error: " +err);
    }); 
    });  

    $(document).on('submit', '#enter-win', function(){
          var kform = $('#enter-win');
          var kmail = kform.find('[name="email"]').val(); 
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
        $source: 'Enter to Win',
              $method_id: 'embed',
        'Accepts Marketing': true,
        'Subscribed to Enter to win': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
        trackLead('Enter to Win');

                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);
            
              kform.find('[class^="input-group"]').hide();
        $('.download-popup h3.h4').text('THANKS FOR SUBSCRIBING.');
        $('.download-popup h3+p').text('YOUR EMAIL IS ON ITS WAY TO YOUR INBOX');
        $('.download-popup .smallprint').hide();

          })
          .catch((err) => {
            console.log("Error: " +err);
          });
    });


    $(document).on('submit', '#register-product-form', function(){
          var kform = $('#register-product-form');
          var kmail = kform.find('[name="email"]').val(); 
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: kreglist,
              email: kmail,
              properties: {
              $source: 'Register',
          $method_id: 'embed',          
              'Accepts Marketing': kform.find('[name="Accepts Marketing"]').val(),
              'Subscribed to Register': currentDate,
              $first_name: kform.find('[name="$first_name"]').val(),
              $last_name: kform.find('[name="$last_name"]').val(),
              'Product': kform.find('[name="Product"] option:selected').val(),
              'Serial No.': kform.find('[name="Serial No."]').val(),                
              'Purchase Date': kform.find('[name="Purchase Date"]').val(),
              'Purchase at': kform.find('[name="Purchased at"]').val()              
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
          trackLead('Register');

                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);
                  var data = {};
                  var att_prod = kform.find('[name="Product"] option:selected').val();
                  var att_serial = "Register " + att_prod + ": Serial No";
                  var att_when   = "Register " + att_prod + ": Purchase Date";
                  var att_where  = "Register " + att_prod + ": Purchased at";
                  data[att_serial] = kform.find('[name="Serial No."]').val();
                  data[att_when]   = kform.find('[name="Purchase Date"]').val();
                  data[att_where]   = kform.find('[name="Purchased at"]').val();
                  /*try {
                    var dateprop = getFormattedDate();
                    var attd_serial = "Register " + att_prod + " @ " + dateprop + ": Serial No";
                    var attd_when   = "Register " + att_prod + " @ " + dateprop + ": Purchase Date";
                    var attd_where  = "Register " + att_prod + " @ " + dateprop + ": Purchased at";
                    data[attd_serial] = kform.find('[name="Serial No."]').val();
                    data[attd_when]   = kform.find('[name="Purchase Date"]').val();
                    data[attd_where]  = kform.find('[name="Purchased at"]').val();
                  } catch (err_gfd) {}*/
                  _learnq.push(['identify', data]);
            
              $('#register-product .stage1').hide();
              $('#register-product .stage2').removeClass('mv-hidden').show();
              $(window).scrollTop(0);
          })
          .catch((err) => {
            console.log("Error: " +err);
          });
    });

    $(document).on('submit', '#contact-form', function(){
          var kform = $('#contact-form');
          var kmail = kform.find('[name="email"]').val(); 
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
              $source: 'Contact Us',
              $method_id: 'embed',
              'Accepts Marketing': kform.find('[name="news"]').val(),
              'Subscribed to Contact Us': currentDate,
              $first_name: kform.find('[name="fname"]').val(),
              $last_name: kform.find('[name="lname"]').val()           
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
              trackLead('Contact Us');
            
                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);

              $('.rte-content').hide();

          })
          .catch((err) => {
            console.log("Error: " +err);
          });
    });

    $(document).on('submit', '#sex-quiz-form', function(){
          var kform = $('#sex-quiz-form');
          var kmail = kform.find('[name="email"]').val(); 
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: kquizlist,
              email: kmail,
              properties: {
              $source: 'Sex Quiz',
              $method_id: 'embed',
              'Accepts Marketing': true,
              'Subscribed to Quiz': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
              trackLead('Sex Quiz');
            
                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);
                  var data = {};
                  $('#sex-quiz-form .inputtext').each(function(i, obj) {
                    if (($(this).val() != "") && ($(this).val().length >= 1)) {
                      data[$(this).attr("name")] = $(this).val();
                    }
                  });
                  _learnq.push(['identify', data]);
          })
          .catch((err) => {
            console.log("Error: " +err);
          });
    });
  
  /*klavscript.onload = function () {
    var currentDate = new Date().toISOString();
  };*/

    $(document).on('click', '.landing-email-btn-foot', function() {
        try {  
          $('.landing-email-email').val($('.landing-email-email-foot').val());
          $('#landing-email').submit();
          $('.landing-email-foot').hide();
          $('html, body').animate({
            scrollTop: "0"
          }, 500);
        } catch (err_lebf) {console.log("ERROR: "+err_lebf.message);}
      });

    $(document).on('click', '.submit-popup-email-btn', function(){
      var kmail = $('.popup-email-field').val();
      if ((kmail.length > 5) && isValidEmail(kmail)) {
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
        $source: 'Popup',
        $method_id: 'embed',
        'Accepts Marketing': true,
        'Subscribed to Popup': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
              trackLead('Popup');

                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);  
            
              Cookies.set('isklaviyo', 'true');
              $('#offer-popup .fancybox-close-small').trigger('click');
              $.fancybox.open([
                {
                  src: '#offer-popup-2',
      },
              ]);

          })
          .catch((err) => {
            console.log("Error: " +err);
          });  
      }
      else {
        $('.popup-email-error').show();
      }

    });
    $(document).on('keyup', '.popup-email-field', function(){
      $('.popup-email-error').hide();
    });
  
    $(document).on('click', '.submit-popup-sms-btn', function(){
      try {
        var kmobile = $('.popup-sms-mobile-number-field').val().replace(/[^0-9+]/g, "");  
        var kmail   = $('.popup-sms-email-field').val();
        if (($(".popup-sms-age-field").is(':checked')) && (kmobile.length > 6) && (kmail.length > 3)) {      
          /*var kodate  = $('.popup-sms-date-field').val();
          var kdate   = kodate.substring(5, 7)+"-"+kodate.substring(8, 10)+"-"+kodate.substring(0, 4);
          console.log(kmail+", "+kmobile+", "+kdate);*/
          console.log(kmail+", "+kmobile);
          $.ajax({
              url: 'https://hooks.zapier.com/hooks/catch/2208180/3d6mujg/',
              type: 'post',
              data: 'email='+kmail+"&mobile="+encodeURIComponent(kmobile),
              success:function(){
                $('#offer-popup-2 .fancybox-close-small').trigger('click');
                $.fancybox.open([
                  {
                    src: '#offer-popup-3',
      },
                ]);                
              }
          });
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  list_id: klist,
                  email: kmail,
                  properties: {
                    $source: 'SMS Popup',
                    $method_id: 'embed',
                    'Accepts SMS': true,
                    'SMS': kmobile
                  }
                }
              }
            })
          };
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
          })
          .catch((err) => {
            console.log("Error: " +err);
          });  
        }
        else {
          $('.popup-sms-error').show();
        }
      } catch (err_sms_popup_buttons) {
        console.log("SMS Popups Error: "+err_sms_popup_buttons.message);
      }  
    });
    
 	$('.popup-sms-age-field').on('click', function() {
      try {
        $('.submit-popup-sms-btn').removeAttr("disabled")
      } catch (err_sms_age_popup_buttons) {
        console.log("SMS Popups Age Error: "+err_sms_age_popup_buttons.message);
      }  
    });
    
    try {
      const smsfield = document.querySelector(".sms-mobile-func");
      const smserrorfield = document.querySelector(".popup-sms-error");
      if (smsfield && smserrorfield) {  
        const iti = window.intlTelInput(smsfield, {
          utilsScript: "//world.mysteryvibe.com/cdn/shop/t/451/assets/intlTelInput-utils.js?v=148855363352623768621788469073",
          initialCountry: "us",
          preferredCountries: ["us", "ca", "gb"]
        });
        const reset = () => {
          console.log("SMS Intl reset");
          smsfield.classList.remove("error");
          $(".popup-sms-error").hide();
          /*smsvalidfield.classList.add("hide");*/
        };
        smsfield.addEventListener('blur', () => {
          reset();
          console.log("SMS Intl blur");
          if (smsfield.value.trim()) {
            if (iti.isValidNumber()) {
              console.log("SMS Intl valid");
              var smsnum = iti.getNumber();
              $('.popup-sms-mobile-number-field').val(smsnum);
              console.log(smsnum);
              /*smsvalidfield.classList.remove("hide");*/
            } else {
              console.log("SMS Intl invalid");
              smsfield.classList.add("error");
              const errorCode = iti.getValidationError();
              smserrorfield.classList.remove("hide");
              $(".popup-sms-error").show();
            }
          }
        });
        smsfield.addEventListener('change', reset);
        smsfield.addEventListener('keyup', reset);
      }
    } catch (err_intl_init) {
      console.log("SMS Intl: "+err_intl_init.message);
    }  
  
    $(document).on('click', '.submit-popup-playdownload-email-btn', function(){
      var kmail = $('.popup-playdownload-field').val();
      if ((kmail.length > 5) && isValidEmail(kmail)) {
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
              $source: 'Playbook Download',
              $method_id: 'embed',
              'Accepts Marketing': true,
              'Subscribed to Playbook Download': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
              trackLead('Playbook Download');
              Cookies.set('isklaviyo', 'true');          

                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);
            
              $('#playdownload-popup .fancybox-close-small').trigger('click');
              downloadFile("//world.mysteryvibe.com/cdn/shop/files/MysteryVibe-Playbook.pdf?v=13742028540246644330", "MysteryVibe-Playbook.pdf");            
          })
          .catch((err) => {
            console.log("Error: " +err);
          });  
      }
      else {
        $('.popup-email-error').show();
      }
    });

      $(document).on('click', '.submit-popup-guidedownload-email-btn', function(){
      var kmail = $('.popup-guidedownload-field').val();
      if ((kmail.length > 5) && isValidEmail(kmail)) {
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
              $source: 'Conversation Download',
              $method_id: 'embed',
              'Accepts Marketing': true,
              'Subscribed to Conversation Download': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
              trackLead('Conversation Download');
              Cookies.set('isklaviyo', 'true');
           
                  var learnq = learnq || [];
                  _learnq.push(['identify', {
                    '$email' : kmail
                  }]);

              $('#guidedownload-popup .fancybox-close-small').trigger('click');
              downloadFile("//world.mysteryvibe.com/cdn/shop/files/MysteryVibe-The-Pleasure-Conversation.pdf?v=3532887735425523320", "MysteryVibe-The-Pleasure-Conversation.pdf");            
          })
          .catch((err) => {
            console.log("Error: " +err);
          });  
      }
      else {
        $('.popup-email-error').show();
      }
    });  

    $(document).on('click', '#submit-collection-email-btn', function(){
          var kform = $('#collection-landing-email');
          var kmail = kform.find('[name="email"]').val(); 
          var klist = kform.find('[name="g"]').val(); 
          const options = {
            method: 'POST',
            headers: {revision: '2023-06-15', 'content-type': 'application/json'},
            body: JSON.stringify({
            data: {
            type: 'subscription',
            attributes: {
              list_id: klist,
              email: kmail,
              properties: {
              	$source: $('#campaignnm').val(),
              	$method_id: 'embed',
              	'Accepts Marketing': true,
              	'Subscribed to a Collection Landing': currentDate
          }}}})};
          fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kstore, options)
          .then((response) => {
            if (!response.ok) {
              console.log("Error: " +response.statusText);
            }
          })
          .then((data) => {
              console.log(data);
              console.log(kmail);
              trackLead($('#campaignel').val());
            
            var learnq = learnq || [];
            _learnq.push(['identify', {
              '$email' : kmail
            }]);
            var data = {};
            var datt = $('#campaignst').attr("name");
            data[datt] = currentDate;
            _learnq.push(['identify', data]);
            
              console.log(datt);
              $('.collection-landing-submit-hide').hide();
              $('.collection-landing-submit-show').show();

             })
          .catch((err) => {
            console.log("Error: " +err);
          }); 
    });  
  
});


function downloadFile(url, fileName){
  fetch(url, { method: 'get', mode: 'no-cors', referrerPolicy: 'no-referrer' })
    .then(res => res.blob())
    .then(res => {
      const aElement = document.createElement('a');
      aElement.setAttribute('download', fileName);
      const href = URL.createObjectURL(res);
      aElement.href = href;
      // aElement.setAttribute('href', href);
      aElement.setAttribute('target', '_blank');
      aElement.click();
      URL.revokeObjectURL(href);
    });
};


function setInnerHeight() {    
  try {
    let onevh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--onevh', `${onevh}px`);
  }
  catch (err_vh) {console.log("ERROR: "+err_vh.message);}  
}
setInnerHeight(); 


$( document ).ready(function() {
  
  try {
      if (window.location.href.toLowerCase().indexOf("redirect=no") > -1) {
          js_createCookie('ipnocountryredirect', 'no', 1);
          console.log("Set no redirect cookie");
      }  
  } catch (err_discount_noredirect) {console.log("ERROR: "+err_discount_noredirect.message);}  

  $(document).on('click touchstart tap', '.country-switch-international', function() {
    try {
      console.log("Click country-popup-contents");
      var newurl_el = $('.country-popup-contents');
      if (newurl_el.length && typeof newurl_el.attr('url') !== 'undefined') {
        var newurl = newurl_el.attr('url');
        console.log("Redirect to "+newurl);
        window.location = newurl;
      }
    } catch (err_country_switch_international) {console.log("ERROR: "+err_country_switch_international.message);} 
  });
  $(document).on('click touchstart tap', '.country-switch-stay', function() {
    try {
      console.log("Click country-switch-stay");
      js_createCookie('ipnocountryredirect', 'no', 3);
      var btn = $('#country-popup .fancybox-close-small');
      if (btn.length) {
        btn.trigger('click');
      }
    } catch (err_country_switch_stay) {console.log("ERROR: "+err_country_switch_stay.message);} 
  });
  
  try {
      if (window.location.href.toLowerCase().indexOf("addp") > -1) {
        var urlparts = window.location.href.split('?');
        var params = []; 
        if (urlparts.length > 1) {
          var paramset = urlparts[1].split('&');
          var parampair;
          for (var i = 0; i < paramset.length; i++) {
            parampair = paramset[i].split('=');
            params[parampair[0]] = parampair[1];        
          }
        }
        if (typeof params['addp'] !== 'undefined') {
          var addp;
          if (params['addp'].indexOf("-") > -1) {
            var addp_list = params['addp'].split("-");
            addp = addp_list.shift();             
            addToCartProductOption(addp, false, addp_list.join("-"));
          }
          else {
            addp = params['addp'];          
            addCartProductOption(addp);
          }
        }
      }  
  } catch (err_add_dproduct) {console.log("ERROR: "+err_add_dproduct.message);} 
  
  function addToCartProductOption(productname, refresh, nextarr) {
    try {
    } catch (err_addCartProductOption) {console.log("ERROR: "+err_addCartProductOption.message); return false;}
  }
  function addCartProductOption(productname) {
    addToCartProductOption(productname, true, false);
  } 
  function addVariantsArray(group, bundles, source, loc) {
    try {
      console.log("addVariantsArray");

    	var params, i;     
    	var bundleid = bundles.pop();
          console.log("Adding bundle variant id '"+bundleid+"', bundles "+bundles.join(','));
        
          var data = {
            "quantity": 1,
            "id": bundleid 
          }
          if (source) {
              data.properties = {
                  '_source': source,
                  '_simple': source
              };  
          }

          if (bundles.length == 0) {
            params = {
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function(line_item) {
                  //CART
                  /*if (loc == "checkout") {
                    window.location.href="/checkout";
                  }
                  else {
                    window.location.href="/cart";
                  }*/
                  if (loc != "null") {
                    openSideCart();
                  }
              },
              error: function(XMLHttpRequest, textStatus) {
              }
            };/*data: { "quantity": 1, "id": bundleid, "properties": { '_bundle': 'P'+group } },*/
          }
          else {
            params = {
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function(line_item) {
                addVariantsArray(group, bundles, source, loc);
              },
              error: function(XMLHttpRequest, textStatus) {
              }
            };/*data: { "quantity": 1, "id": bundleid, "properties": { '_bundle': 'P'+group } },*/
          }
          return jQuery.ajax(params);          
      
    } catch (errf) {return false;}
  }
  function checkoutDiscountProducts(discount, products) {
    window.location.href = "/discount/"+discount+"?redirect=/cart&addp="+products+"&chkp=true";
  }  
  $(document).on('click', '.clicklinkattr', function() {
      try {  
        window.location.href = $(this).attr('clicklinkattr');
      } catch (err_clicklinkattr) {console.log("ERROR: "+err_clicklinkattr.message);}
  });   
  $(document).on('click', '.submitcartbtn', function() {
    try { 
      $('form.sub-form').submit();
     } catch (err_product_submit_addtocart) {}             
  }); 
  try {
    if (typeof cartPolicies == 'function') {
    	cartPolicies();
    }
  } catch (err_cartPolicies) {console.log("Error: "+err_cartPolicies.message);}
  try {
    if (typeof productPolicies == 'function') {
    	productPolicies();
    }
  } catch (err_productPolicies) {console.log("Error: "+err_productPolicies.message);} 

  $(document).on('click', '.collection-hero-bundle-content .pgrid-btn-bundle button', function() {
    try { 
        console.log("collection-hero-bundle-content button");
        var bundlesstr = $(this).parent().attr('bundle');
        var bundlegroup = $(this).parent().attr('bundlegroup')+"";
        var bundles = bundlesstr.split("+");
        addVariantsArray(bundlegroup, bundles, false, 'cart');  
		return false;
     } catch (err_collection_hero_bundle) {console.log("Error "+err_collection_hero_bundle.message);}            
  });
    
  $(document).on('click', '.add-items-link', function() {
    try { 
        console.log("add-items-link button");
        var bundlesstr = $(this).attr('bundle');
		    var bundles = bundlesstr.split("+");
        if ($(this).attr('checkout')) {
    		addVariantsArray(false, bundles, false, 'checkout'); 
        } else {
    		addVariantsArray(false, bundles, false, 'cart'); 
        }
        try {
          //ADD TO CART EVENTS
        } catch (err_add_items_conn) {console.log("Error "+err_add_items_conn.message);} 
		return false;
     } catch (err_add_items_link) {console.log("Error "+err_add_items_link.message);}            
  });

  $(document).on('click', '.add-prouctpage-upsells-link', function() {
    try { 
        console.log("add-prouctpage-upsells-link button");
        var primaryRequest = $.Deferred().resolve().promise();
        var primary = $(this).attr('primary');
        var link = this;
        if (primary) {
          console.log("prouctpage upsell primary "+primary);
          primaryRequest = addVariantsArray(false, primary.split("+"), false, 'null') || $.Deferred().resolve().promise();
        }
        primaryRequest.then(function () {
          var bundlesstr = $(link).attr('bundle');
          if (bundlesstr) {
            console.log("prouctpage upsell bundles "+bundlesstr);
            var bundles = bundlesstr.split("+");
            if ($(link).attr('checkout')) {
            addVariantsArray(false, bundles, $(link).attr('source') || false, 'checkout'); 
            } else {
            addVariantsArray(false, bundles, $(link).attr('source') || false, 'cart'); 
            }
          }
          else {
            openSideCart();
          }
        });
        try {
          //ADD TO CART EVENTS
        } catch (err_add_items_conn) {console.log("Error "+err_add_items_conn.message);} 
		return false;
     } catch (err_add_items_link) {console.log("Error "+err_add_items_link.message);}            
  });
    
  $(document).on('click', '.product-main-content .product-hero-add', function() {
    try {
        console.log("product-main-content product-hero-add");
        //$('form.productpage-form').submit();
        $('.product-form-add').trigger('click');
     } catch (err_product_submit_addtocart) {console.log("Error "+err_product_submit_addtocart.message);}               
  }); 
  $(document).on('click', '.product-lower-add', function() {
    try {
        console.log("product-lower-add");
        //$('form.productpage-form').submit();
        $('.product-form-add').trigger('click');
     } catch (err_product_submit_addtocart) {console.log("Error "+err_product_submit_addtocart.message);}               
  });  

  $(document).on('click', '.product-child-add', function() {
	try { 
        console.log("product-child-add");
      	$('.product-btn').trigger('click');
  	} catch (err_product_child_btn) {}
  });  

  $(document).on('click', '.product-form-add', function() {
    try {    
      var btnitem = $(this);
      var frm = $('.productpage-form');
      frm.submit(function (ev) {
          $.ajax({
              type: frm.attr('method'),
              url: frm.attr('action'),
              data: frm.serialize(),
              success: function (data) {
                try {
                  var price = "";
                  var prod = "";
                  if ($('.product-form-add').length) {
                    if ($('.product-form-add').attr('price')) {
                      price = $('.product-form-add').attr('price');
                    }
                    if ($('.product-form-add').attr('product')) {
                      prod = $('.product-form-add').attr('product');
                    }
                  }
                  else if ($('.product-hero-add').length) {
                    if ($('.product-hero-add').attr('price')) {
                      price = $('.product-hero-add').attr('price');
                    }
                    if ($('.product-hero-add').attr('product')) {
                      prod = $('.product-hero-add').attr('product');
                    }
                  }
                  console.log("Product '"+prod+"' price '"+price+"'");
                  try {
                    //ADD TO CART EVENTS
                  } catch (err_liveconnectadd2) {console.log("Error "+err_liveconnectadd2.message);}
                } catch (err_liveconnectadd) {console.log("Error "+err_liveconnectadd.message);}
                setTimeout(function() {
                  openSideCart();
                  /*if (btnitem.attr('checkout')) {
	                  window.location.href="/checkout"; 
	                }
	                else if (btnitem.attr('cart')) {
	                  window.location.href="/cart";
	                }
	                else {
	                  window.location.href="/cart";
                  }*/
                }, 100);
              }
          });
          ev.preventDefault();
      });    
    } catch (err_product_form_addtocart) {console.log("Error "+err_product_form_addtocart.message);}               
  });   

  $(document).on('click', '.healthline-link', function() {
	try { 
      console.log("healthline-link");
      if ($(this).attr("link") && ($(this).attr("link") != "")) {
      	window.location.href = $(this).attr("link")+"";
      }
  	} catch (err_product_child_btn) {}
  });  
  
});

function copyToClipboard(clip) {
  try {
    navigator.clipboard.writeText(clip);
    $('.discount-popup-tooltop').attr("title", "Copied: " + clip);
  } catch (err_clipboard) {console.log("Error "+err_clipboard.message);}
}
function copiedClipboard() {
  try {
    $('.discount-popup-tooltop').attr("title", "Copy to clipboard");
  } catch (err_clipboard) {console.log("Error "+err_clipboard.message);}
}

$(document).ready(function() {
  $('.header-variant-selector').on('change', function() {
    try {
      var selectedValue = $(this).val();
      $('.body-variant-selector input[type="radio"]').each(function() {
        if ($(this).val() == selectedValue) {
          $(this).prop('checked', true);
        }
      });
    } catch (err_headervariantselector) {console.log("Error "+err_headervariantselector.message);}
  });
  $('.body-variant-selector input[type="radio"]').on('change', function() {
    try {
      var selectedValue = $(this).val();
      $('.header-variant-selector').val(selectedValue).trigger('change');
    } catch (err_bodyvariantselector) {console.log("Error "+err_bodyvariantselector.message);}
  });
});

  function getUrlParams() {
    try {
        //var urlparts = window.location.href.split('?');
        var urlparts = window.location.href.toLowerCase().split('?');
        var params = []; 
        if (urlparts.length > 1) {
          var paramset = urlparts[1].split('&');
          var parampair;
          for (var i = 0; i < paramset.length; i++) {
            parampair = paramset[i].split('=');
            params[parampair[0]] = parampair[1];        
          }
        }
       return params;
    } catch (err_params) {console.log("ERROR: "+err_params.message); return [];} 
  }

  function hasUrlParam(key, value) {
    try {
      var params = getUrlParams();
      var k = key.toLowerCase();
      if (typeof params[k] === "undefined") return false;
      if (typeof value === "undefined") return true;
      var v = value.toLowerCase();
      return params[k] == v;
    } catch (err_params) {console.log("ERROR: "+err_params.message); return false;} 
  }




